import React from "react";

/** Preserve the page hierarchy for search engines without a visible breadcrumb band. */
export default function Breadcrumbs({ items = [], testid = "breadcrumbs" }) {
  if (!items || items.length === 0) return null;
  const origin = "https://timefurniture.ae";
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `${origin}${it.to}` } : {}),
    })),
  };
  return (
    <script
      data-testid={testid}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
